import { render, staticRenderFns } from "./EnterTips.vue?vue&type=template&id=6b406b76&scoped=true&"
import script from "./EnterTips.vue?vue&type=script&lang=js&"
export * from "./EnterTips.vue?vue&type=script&lang=js&"
import style0 from "./EnterTips.vue?vue&type=style&index=0&id=6b406b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b406b76",
  null
  
)

export default component.exports